import { Link } from 'react-router';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const rootCss = ({ breakpoints, palette, spacing }) => ({
  overflow: 'auto',
  padding: spacing(1),
  '.PMES-paper': {
    maxWidth: 600,
    margin: 'auto',
    padding: spacing(4),
    backgroundColor: palette.background.paper,
  },
  '.PMES-actions': {
    marginTop: spacing(2),
    display: 'flex',
    justifyContent: 'center',
    '& > *': {
      minWidth: 130,
      '& + *': { marginLeft: spacing(2) },
    },
  },
  [breakpoints.only('xs')]: {
    '.PMES-paper': { padding: spacing(2) },
  },
});

export default function OnlineCoursePracticeModeEmptyState({ nextAndPrev: { next, prev } }) {
  return (
    <div css={rootCss}>
      <Paper className="PMES-paper" variant="outlined">
        <Typography align="center" variant="h6">
          We don&apos;t have questions for this section yet, but we&apos;re working on it.
        </Typography>
        <div className="PMES-actions">
          <Button
            component={prev ? Link : undefined}
            disabled={!prev}
            nativeButton={prev ? false : undefined}
            size="small"
            to={prev?.path}
            variant="outlined"
          >
            Previous Section
          </Button>
          <Button
            component={next ? Link : undefined}
            disabled={!next}
            nativeButton={next ? false : undefined}
            size="small"
            to={next?.path}
            variant="contained"
          >
            Next Section
          </Button>
        </div>
      </Paper>
    </div>
  );
}
